<template>
  <section>
    <gs-header title="Quản lý phường xã">
      <router-link :to="{ name: 'create-ward' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="wardTable" :table-name="wardTable" data-source="wards" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-select v-model="filters.city_id" filterable placeholder="Chọn tỉnh thành" @change="getDistricts"
                class="width-100">
                <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="filters.district_id" filterable placeholder="Chọn quận huyện" @change="filter"
                class="width-100">
                <el-option v-for="district in districts" :key="district.id" :label="district.name" :value="district.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border :row-class-name="tableRowClassName" style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[wardTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[wardTable].current_page - 1) * dataPaginations[wardTable].per_page)}}</small>
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="Tỉnh thành"
              width="100"
            >
              <template slot-scope="scope">
                <p><span class="shipment-code-display">{{scope.row.id}}</span></p>
              </template>
            </el-table-column> -->

            <el-table-column label="Tên" width="350">
              <template slot-scope="scope">
                <p>{{ scope.row.fullname }}</p>
              </template>
            </el-table-column>


            <el-table-column v-for="(carrier, index) in listCarriers" :key="index" :label="carrier.name">
              <template slot-scope="scope">
                <p><span class="shipment-code-display text-normal-case">{{ scope.row[carrier.key] }}</span></p>
              </template>
            </el-table-column>


            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block cursor-pointer"
                      :to="{ name: 'edit-ward', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.deleted_at">
                    <a @click.prevent="deleteWard(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Khôi phục" class="display-inline" v-if="scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click="restore(scope.row)"><i
                        class="fa fa-refresh" aria-hidden="true"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce, keys, forEach } from 'lodash'
import ls from 'local-storage'
import { deleteWard, restoreWard } from 'src/api/ward'
import { listCarriers } from 'src/stubs/carriers'
export default {
  name: 'Ward',
  data() {
    return {
      wardTable: 'wards',
      filters: {
        city_id: '',
        district_id: '',
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      listCarriers: listCarriers
    }
  },
  computed: {
    ...mapGetters('city', ['city', 'cities']),
    ...mapGetters('district', ['districts']),
    ...mapGetters('ward', ['ward'])
  },
  methods: {
    ...mapActions('city', ['getAllCity']),
    ...mapActions('district', ['getDistrictByCityId']),
    ...mapActions('ward', ['getWard', 'setWard']),
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.wardTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.wardTable)
      }
    }, 300),
    removeFilter() {
      if (!this.checkDefaultFilter({
        city_id: '',
        district_id: '',
        sort: 'created_at:-1'
      })) {
        this.reloadGsTable(this.wardTable)
      }
      this.filters = {
        city_id: '',
        district_id: '',
        sort: 'created_at:-1'
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    deleteWard(ward) {
      this.setWard(ward)
      this.$confirm(`Bạn chắc chắn muốn xóa phường xã ${this.ward.name}`, 'Xóa phường xã', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delWard()
      }).catch(() => {

      })
    },
    delWard() {
      deleteWard(this.ward.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa phường xã thành công'
          })
          this.reloadGsTable(this.wardTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa phường xã thất bại'
          })
        }
      })
    },
    tableRowClassName(row) {
      if (row.deleted_at) {
        return 'row-orange'
      }
      return null
    },
    restore(ward) {
      this.setWard(ward)
      this.$confirm(`Bạn chắc chắn muốn khôi phục phường xã ${this.ward.name}`, 'Khôi phục phường xã', {
        confirmButtonText: 'Khôi phục',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.resWard()
      }).catch(() => {

      })
    },
    resWard() {
      restoreWard(this.ward.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Khôi phục phường xã thành công'
          })
          this.reloadGsTable(this.wardTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Khôi phục phường xã thất bại'
          })
        }
      })
    },
    getDistricts() {
      this.filters.district_id = ''
      this.getDistrictByCityId({ city_id: this.filters.city_id, limit: -1, sort: 'name:1' })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.wardTable]) {
      this.filters = ls.get('filters')[this.wardTable]
      setTimeout(() => {
        this.filters.district_id = ls.get('filters')[this.wardTable].district_id
        ls.set('doFilter', true)
      }, 100)
    }
    if (!this.cities.length) {
      this.getAllCity({ limit: -1, sort: 'name:1' })
    }
    this.sorted = this.getSorted(this.wardTable)
    this.listenReloadGsTable()
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['wards']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Ward.vue?07dc9bc9